import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class RegionInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const region = this.authService.regionValue;
    if (!region) {
      return next.handle(request);
    }

    const cloned = request.clone({
      setHeaders: { 'Region-Id': region }
    });

    return next.handle(cloned);
  }
}
